import { render } from "./PastShiftsDataTable.vue?vue&type=template&id=a6f0b144"
import script from "./PastShiftsDataTable.vue?vue&type=script&lang=js"
export * from "./PastShiftsDataTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__